import React from 'react';
const StatisticsBar = () => {
  return <div className="flex flex-wrap justify-center space-x-4 space-y-2 md:space-y-0" data-id="element-753">
      <div className="text-center" data-id="element-754">
        <h3 className="text-2xl font-bold text-black" data-id="element-755">$4.5m+</h3>
        <p className="text-xs text-black" data-id="element-756">Transactions Processed</p>
      </div>
      <div className="text-center" data-id="element-757">
        <h3 className="text-2xl font-bold text-black" data-id="element-758">400k+</h3>
        <p className="text-xs text-black" data-id="element-759">Tickets Processed</p>
      </div>
      <div className="text-center" data-id="element-760">
        <h3 className="text-2xl font-bold text-black" data-id="element-761">1800+</h3>
        <p className="text-xs text-black" data-id="element-762">Live Events</p>
      </div>
      <div className="text-center" data-id="element-763">
        <h3 className="text-2xl font-bold text-black" data-id="element-764">150k+</h3>
        <p className="text-xs text-black" data-id="element-765">Unique Buyers</p>
      </div>
      <div className="text-center" data-id="element-766">
        <h3 className="text-2xl font-bold text-black" data-id="element-767">10m+</h3>
        <p className="text-xs text-black" data-id="element-768">Page Views</p>
      </div>
    </div>;
};
export default StatisticsBar;